var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title'),_c('v-card-text',{staticStyle:{"max-height":"500px","overflow-y":"auto"}},[_c('SelectableIngredientGroupList',{attrs:{"selectedIngredients":_vm.selectedIngredients},on:{"select":_vm.select}})],1),_c('v-card-actions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }